import GenerateEnum from '../generateEnum'
import { getLabelText } from '../utils'
/**
 * 合规类型枚举
 * 0: VAT
 * 1: EPR
 * 2: 检测认证
 * 3: 授权代表
 * 999: 预警（预警表一定得带上这个值）
 */
export const LINK_SAFE_COMPLIANCE_TYPE = GenerateEnum({
  VAT: { value: 0, label: getLabelText({ key: 'remote.common.complianceTypeVat', text: 'VAT' }) },
  EPR: { value: 1, label: getLabelText({ key: 'remote.common.complianceTypeEpr', text: 'EPR' }) },
  AUTHORIZATION_REPRESENTATIVE: { value: 3, label: getLabelText({ key: 'remote.common.complianceTypeAuthRep', text: '授权代表' }) },
  DETECTION_AUTHORIZATION: { value: 2, label: getLabelText({ key: 'remote.common.complianceTypeDetectionAuth', text: '检测认证' }) },
  // WARNING: { value: 999, label: getLabelText({ key: 'remote.common.complianceTypeWarning', text: '预警' }) }
})

/**
 * 合规状态枚举
 * 0: 禁用
 * 1: 启用
 */
export const LINK_SAFE_COMPLIANCE_STATUS = GenerateEnum({
  DISABLED: { value: 0, label: getLabelText({ key: 'remote.common.complianceStatusDisabled', text: '禁用' }) },
  ENABLED: { value: 1, label: getLabelText({ key: 'remote.common.complianceStatusEnabled', text: '启用' }) }
})

/**
 * 预警，导出状态 0 未导出  1 已导出
 */
export const WARNING_DATABASE_EXPORT_STATUS = GenerateEnum({
  UNEXPORTED: { value: 0, label: '未导出' },
  EXPORTED: { value: 1, label: '已导出' }
})

/**
 *强制类型，平台强制、官方强制、非强制
 */
export const ENFORCEMENT_TYPE = GenerateEnum({
  PLATFORM: { value: '平台强制', label: '平台强制' },
  OFFICIAL: { value: '官方强制', label: '官方强制' },
  NORMAL: { value: '非强制', label: '非强制' }
})


// 筛选项增加“检测方式”，单选下拉框，默认为请选择（即全部），选项值有链接检测、非链接检测，
export const LINK_SAFE_DETECT_TYPE = GenerateEnum({
  LINK: {
    value: 0,
    label: getLabelText({
      key: 'remote.common.linkDetection',
      text: '链接检测'
    })
  },
  NON_LINK: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.nonLinkDetection',
      text: '非链接检测'
    })
  }
})

/**
 * 比较类型枚举
 * 0: 包含
 * 1: 等于
 * 2: 不等于
 * 3: 不包含
 */
export const COMPARE_TYPE_ENUM = GenerateEnum({
  CONTAIN: { value: 0, label: getLabelText({ key: 'remote.common.compareTypeContain', text: '包含' }) },
  EQUAL_TO: { value: 1, label: getLabelText({ key: 'remote.common.compareTypeEqualTo', text: '等于' }) },
  NOT_EQUAL_TO: { value: 2, label: getLabelText({ key: 'remote.common.compareTypeNotEqualTo', text: '不等于' }) },
  NOT_CONTAIN: { value: 3, label: getLabelText({ key: 'remote.common.compareTypeNotContain', text: '不包含' }) }
})

/**
 * 关联条件类型枚举
 * 0: 国家
 * 1: 品类
 * 2: 材质
 */
export const ASSOCIATED_TYPE_ENUM = GenerateEnum({
  COUNTRY: { value: 0, label: getLabelText({ key: 'remote.common.associatedTypeCountry', text: '国家' }) },
  CATEGORY: { value: 1, label: getLabelText({ key: 'remote.common.associatedTypeCategory', text: '品类' }) },
  MATERIAL: { value: 2, label: getLabelText({ key: 'remote.common.associatedTypeMaterial', text: '材质' }) }
})




// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/enum/linkSafe.js